import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAWSduHSZLefcpcpcbBbFt3f4HMCS7_rG0",
  authDomain: "helm-12345.firebaseapp.com",
  projectId: "helm-12345",
  storageBucket: "helm-12345.appspot.com",
  messagingSenderId: "379332932787",
  appId: "1:379332932787:web:helm12345"  // Replace with actual appId if you have it
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;

